import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSizeA, selectSizeB, selectSizeC } from '@store/order/selectors';



const AnimalDimensions = () => {
	const { t } = useTranslation('forms');

	const sizeA = useSelector(selectSizeA);
	const sizeB = useSelector(selectSizeB);
	const sizeC = useSelector(selectSizeC);

	return (
		<div className='order-summary-element'>

			<h2>{t('animalInfo.dimensions.sectionLabel')}</h2>

			<div className='summary-grid'>
				
				{sizeA && sizeA > 0 &&
					<p>{t('animalInfo.dimensions.imageDogA') + ':'}</p>}
				{sizeA && sizeA > 0 &&
					<p>{`${sizeA ? sizeA : 0} ${t('units.dimensionUnit')}`}</p>}
				
				<p>{t('animalInfo.dimensions.imageDogB') + ':'}</p>
				<p>{`${sizeB ? sizeB : 0} ${t('units.dimensionUnit')}`}</p>

				<p>{t('animalInfo.dimensions.imageDogC') + ':'}</p>
				<p>{`${sizeC ? sizeC : 0} ${t('units.dimensionUnit')}`}</p>
			
			</div>

		</div>
	);
};

export default AnimalDimensions;